var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "waveWrapper waveAnimation" },
    _vm._l(["Top", "Middle", "Bottom"], function(className) {
      return _c(
        "div",
        {
          key: className,
          staticClass: "waveWrapperInner",
          class: "bg" + className
        },
        [_c("div", { staticClass: "wave", class: "wave" + className })]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cd1cc9a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd1cc9a6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/WaveAnimation.vue
// module id = 2545
// module chunks = 129 131 132 133 134 135 136 137 138 139 140 141 142 143 144